import * as WebServicesHelper from "../helpers/WebServicesHelper";

export async function fetchIntegratedSecurityUserSID() {
  return await fetch("./api/WindowsIdentity/IntegratedSecurityUser", {
    method: WebServicesHelper.GET_METHOD,
    headers: WebServicesHelper.getDefaultJsonHeaders()
  })
    .then(WebServicesHelper.checkStatus)
    .then(res => res.json())
    .then(json => {
      //console.log("Username: " + json.userName, "SID: " + json.windowsSID);
      return json.windowsSID;
    });
}

export async function fetchAppConfig() {
  return await fetch("./api/AppConfiguration/GetAppConfig", {
    method: WebServicesHelper.GET_METHOD,
    headers: WebServicesHelper.getDefaultJsonHeaders()
  })
    .then(WebServicesHelper.checkStatus)
    .then(res => res.json())
    .then(json => {
      //console.log("AppConfig Urls: ", json.bosIdentityServiceUrl, json.bosWebGuiServiceUrl);
      return json;
    });
}

export async function fetchStoreClientId(clientId) {
  let params = "/" + clientId;
  return await fetch("./api/AppConfiguration/StoreClientId" + params, {
    method: WebServicesHelper.POST_METHOD,
    headers: WebServicesHelper.getDefaultJsonHeaders()
  })
    .then(WebServicesHelper.checkStatus);
}
